module.exports = __webpack_public_path__ + "img/hero-3-mobile.5e07a4be.jpg";